import { render, staticRenderFns } from "./dispositivos_lista.vue?vue&type=template&id=2be4ba71&"
import script from "./dispositivos_lista.vue?vue&type=script&lang=ts&"
export * from "./dispositivos_lista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports